export class BatchResult {
    constructor(
        public readonly genusId?: string,
        public readonly contents?: any[]
    ) {
    }
}
